import { OdinIcon } from '@myosh/odin-components';
import React, { useCallback } from 'react';
import type { ExportRecordFieldApiProps } from '../../@types/records';
import { type FileBackgroundJobDetails, JobStatus } from '../../redux/slices/background-job-slice';
import { downloadFileFromUrl } from '../../utils/file-download';
import type { BackgroundJobPanelItemProps } from './background-job-panel.component';
import BaseJobPanelItem from './base-job-panel-item.component';

const RecordFieldBackgroundJobItem = ({
  job,
  onRemove,
}: BackgroundJobPanelItemProps<ExportRecordFieldApiProps, FileBackgroundJobDetails>) => {
  const handleClick = useCallback(() => {
    const { fileName, presignedUrl } = job.details || {};

    if (job.status !== JobStatus.Success || !fileName || !presignedUrl) {
      return;
    }

    downloadFileFromUrl(presignedUrl, fileName);
  }, [job.details, job.type, job.status]);

  return (
    <BaseJobPanelItem
      title={job.details?.fileName ?? 'No file name available'}
      status={job.status}
      onRemove={onRemove}
      onClick={handleClick}
      icon={<OdinIcon icon="FileText" />}
    />
  );
};

export default React.memo(RecordFieldBackgroundJobItem);
